export const rowsHighCh2 = {
    25: 2,
    26: 4,
    29: 6,
    30: 8,
    31: 10,
    27: 13,
    28: 15,
};
//# sourceMappingURL=rowsHighCh2.js.map